<template>
    <div class="card"
        style="padding: 24px; border-top-left-radius: 0 !important; border-top-right-radius: 0; border-radius: 10px">
        <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.6em; padding-left: 6px;">
            Documents Required
        </div>
        <div class="col-md-12 font-weight-bold mb-4" style="font-size: 1.2em; padding-left: 6px;">
            {{ data.benefit.name }}
        </div>
        <div class="table-responsive">
            <table id="claim_documents_tbl" class="display table table-striped table-bordered" style="width:100%;">
                <thead class="text-center">
                    <tr>
                        <th>No.</th>
                        <th>Document</th>
                        <th>Uploaded Date</th>
                        <th>Documents</th>
                    </tr>
                </thead>
                <tbody class="text-center">
                    <tr v-for="(document, index) in data.benefit.documents" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ document.name }}</td>
                        <td>
                            {{Array.from(new Set(document.files.map(file => file.created_at))).join(', ')}}
                        </td>
                        <td>
                            <span>
                                <span v-for="(file, index) in document.files" :key="index">
                                    <div v-if="file.name != 'Baggage Details'"
                                        style="color: green; cursor: pointer; margin-right: 4px;"
                                        @click="openImage(file.id)">
                                        Image[{{ index + 1 }}]
                                        <span v-if="index < document.files.length - 1"
                                            style="margin-left: -4px;">,</span>
                                    </div>
                                    <div v-if="file.name === 'Baggage Details'">
                                        Brand: <strong>{{ file.brand }}</strong> ,
                                        Amount in $B: <strong>{{ file.amount }}</strong>
                                    </div>
                                </span>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
import axios from "axios";

export default {
    name: "DocumentClaim",
    props: {
        data: {
            type: Object,
            required: true
        }
    },

    methods: {
        openImage(id) {
            let token = localStorage.getItem("token");
            if (token !== null) {
                token = JSON.parse(token);
                token = token.access_token;
                axios
                    .get("/download/" + id, {
                        headers: {
                            Authorization: "Bearer " + token
                        },
                        responseType: "blob"
                    })
                    .then(res => {
                        let type = "image/x-png, image/gif, image/jpeg, image/jpg";

                        let blob = new Blob([res.data], { type: type }),
                            url = window.URL.createObjectURL(blob);

                        window.open(url);
                    });
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            $('#claim_documents_tbl').DataTable({
                pageLength: 5,
                dom: 'Bfrtip',
                buttons: [],
            });
        });
    },
};
</script>
